import {
  Box,
  Card,
  Chip,
  CircularProgress,
  Grid,
  LinearProgress,
  LinearProgressProps,
  Typography,
} from '@mui/material';
import { JSX, ReactElement, useEffect, useState } from 'react';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { InfoIcon } from 'shared/components/AppIcons';
import { TEVVService } from 'services/TEVVService';
import { Utils } from 'shared/helpers';
import { useParams } from 'react-router-dom';

// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const LinearProgressWithLabel = (
  props: LinearProgressProps & { value: number }
) => (
  <Box sx={{ position: 'relative', width: '100%' }}>
    <LinearProgress variant="determinate" {...props} />
    <Typography
      variant="h4"
      sx={{
        position: 'absolute',
        bottom: -35, // கீழே move
        left: '50%',
        transform: 'translateX(-50%)',
        color: 'text.primary',
      }}
    >
      {
        // eslint-disable-next-line react/destructuring-assignment
        `${Math.round(props.value)}%`
      }{' '}
      Complete
    </Typography>
  </Box>
);

export interface DocumentProps {
  _id: string;
  stage: string;
  aisystemId: string;
  category: string;
  type: string;
  status: string;
  description: string;
  isRequired: boolean;
  organizationId: string;
  templateId: string;
  fileDetails: any[];
  createdAt: string;
  updatedAt: string;
  __v: number;
}

const intialData = [
  {
    _id: '69c12d35b9fe5fde075f88e4',
    stage: 'Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Operational Testing',
    type: 'A/B Testing Results',
    status: 'pending',
    description: 'Results from A/B testing of model in production environment',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.596Z',
    updatedAt: '2026-03-23T12:08:21.596Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88e6',
    stage: 'Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Security Monitoring',
    type: 'Security Audit Reports',
    status: 'pending',
    description: 'Regular security audit reports for the deployed AI system',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88ec',
    stage: 'Operation and monitoring',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Manual Fallback Procedures',
    status: 'pending',
    description:
      'Written procedures for when and how an AI system can be bypassed, paused, or overridden',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88eb',
    stage: 'Operation and monitoring',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Human-in-the-Loop Protocols',
    status: 'pending',
    description:
      'Documentation of manual fallback processes and human intervention protocols',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88e9',
    stage: 'Design and development',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Business Continuity Plans',
    status: 'pending',
    description:
      'Business continuity planning (BCP) and disaster recovery (DR) documentation related to AI operations',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88e8',
    stage: 'Design and development',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Architecture Diagrams',
    status: 'pending',
    description:
      'Architecture diagrams showing backup systems, redundancies, and failover mechanisms',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88e7',
    stage: 'Design and development',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Alternate AI Models Documentation',
    status: 'pending',
    description:
      'Documentation of alternate AI models or decision-support tools that can be swapped in',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88ea',
    stage: 'Operation and monitoring',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Bypass Trigger Criteria',
    status: 'pending',
    description:
      'Criteria and thresholds for triggering system bypass (e.g., anomaly detection, threshold violations)',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88e5',
    stage: 'Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Performance Monitoring',
    type: 'Drift Detection',
    status: 'pending',
    description:
      'Monitoring for data and model drift in production environment',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88f0',
    stage: 'Pre-Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Model Testing',
    type: 'Performance Validation',
    status: 'pending',
    description:
      'Validation of model performance metrics against established thresholds',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88ef',
    stage: 'Pre-Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Model Testing',
    type: 'Bias and Fairness Testing',
    status: 'pending',
    description:
      'Testing for bias and fairness across demographic groups and sensitive attributes',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88f1',
    stage: 'Pre-Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Security Testing',
    type: 'Adversarial Testing',
    status: 'pending',
    description:
      'Testing for robustness against adversarial examples and attacks',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88f3',
    stage: 'Verification and validation',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Chaos Engineering Tests',
    status: 'pending',
    description:
      'Logs or outputs from chaos engineering tests or business continuity exercises',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88f4',
    stage: 'Verification and validation',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Failure Simulation Logs',
    status: 'pending',
    description:
      'Records of simulated AI failures, failover drills, or bypass scenario walkthroughs',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88f2',
    stage: 'Verification and validation',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'System Failure',
    type: 'Bypass Event Audit Logs',
    status: 'pending',
    description:
      'Screenshots/logs from tabletop exercises, reports from system downtime simulations, audit logs of actual bypass events',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88ed',
    stage: 'Pre-Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Data Evaluation',
    type: 'Data Quality Assessment',
    status: 'pending',
    description:
      'Evaluation of training and test data quality and representativeness',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
  {
    _id: '69c12d35b9fe5fde075f88ee',
    stage: 'Pre-Deployment TEVV',
    aisystemId: '69c12d35b9fe5fde075f88e1',
    category: 'Integration Testing',
    type: 'System Integration Tests',
    status: 'pending',
    description: 'Testing of AI system integration with other components',
    isRequired: false,
    organizationId: '699d80dda963440de7c438f9',
    templateId: '69b7ea39e832b3445d352195',
    fileDetails: [],
    createdAt: '2026-03-23T12:08:21.597Z',
    updatedAt: '2026-03-23T12:08:21.597Z',
    __v: 0,
  },
];

const Complience = (): ReactElement => {
  const { aiSystemId } = useParams();
  const [templateList, setTemplateList] = useState<DocumentProps[]>([
    ...intialData,
  ]);
  const [isLoading, setIsLoading] = useState(false);

  const getTemplateList = (): void => {
    setIsLoading(true);
    if (aiSystemId) {
      TEVVService.getFileDetail(aiSystemId)
        .then((res) => {
          const { data } = res.data;
          if (data && data.length > 0) {
            setTemplateList(data.filter((d: any) => d.basecategory === 'tevv'));
          }
        })
        .catch((error) => {
          Utils.handleErrorResponse(error);
        })
        .finally(() => {
          setIsLoading(false);
        });
    }
  };

  const getTemplates = (template: any): JSX.Element => (
    <Card className="p-4" sx={{ flex: 1 }}>
      <Box sx={{ height: '100%' }}>
        <Box className="align-center ">
          {template.fileDetails.length > 0 ? (
            <CheckCircleIcon sx={{ color: 'green' }} fontSize="small" />
          ) : (
            <InfoIcon sx={{ color: 'red' }} fontSize="small" />
          )}

          <Typography variant="h3" className="mx-2">
            {template.type}
          </Typography>
          {/* {getDocumentStatus(template.status)}
           */}
          {template.fileDetails.length > 0 ? (
            <Chip
              label="Compliant"
              className="mx-2"
              sx={{ background: 'black', color: 'white' }}
              size="small"
            />
          ) : (
            <Chip
              label="Missing"
              className="mx-2"
              sx={{ background: 'red', color: 'white' }}
              size="small"
            />
          )}
        </Box>
        <Box className="flex mt-2 mb-2">
          <Chip
            label={template.stage}
            className="mx-2"
            sx={{
              background: 'white',
              color: 'primary',
              border: '1px solid black',
            }}
            size="small"
          />
          <Chip
            label={template.category}
            className="mx-2"
            sx={{
              background: 'white',
              color: 'primary',
              border: '1px solid black',
            }}
            size="small"
          />
        </Box>
        <Typography variant="body1" className="mx-2">
          {template.description}
        </Typography>
        {template.fileDetails.length > 0 && (
          <Typography
            variant="body1"
            sx={{ color: '#0aab0a' }}
            className="mx-2"
          >
            {' '}
            {template.fileDetails.length} document(s) uploaded
          </Typography>
        )}
      </Box>
    </Card>
  );

  const total = templateList.length;

  const completed = templateList.filter(
    (obj) => obj.fileDetails?.length > 0
  ).length;

  const percentage = total > 0 ? (completed / total) * 100 : 0;

  useEffect(() => {
    getTemplateList();
  }, []);

  return (
    <>
      <Box className="m-3">
        {isLoading && (
          <Box className="empty-content">
            <CircularProgress />
          </Box>
        )}
        {!isLoading && (
          <>
            <Card className="p-5">
              <Box className="align-center mb-2">
                <InfoIcon className="mx-2" />
                <Typography variant="h2">Overall TEVV Complience</Typography>
              </Box>
              {templateList.length > 0 && !isLoading && (
                <>
                  <Box className="justify-space-between">
                    <Typography variant="body1" className="mb-2">
                      Complience Progress
                    </Typography>

                    <Typography variant="body1">
                      {completed} of {total} required
                    </Typography>
                  </Box>
                  <Box className="progress-wrapper pb-10">
                    <LinearProgressWithLabel
                      variant="determinate"
                      value={percentage}
                      sx={{ height: 15, borderRadius: 5 }}
                    />
                  </Box>
                </>
              )}
            </Card>

            <Card className="mt-10 p-5">
              <Typography variant="h2">Required TEVV Documents</Typography>
              {templateList.length > 0 && !isLoading && (
                <Grid container spacing={3} mt={2}>
                  {templateList
                    .filter((obj) => obj.isRequired)
                    .map((template) => (
                      <Grid xs={6} item spacing={3} sx={{ display: 'flex' }}>
                        {getTemplates(template)}
                      </Grid>
                    ))}
                </Grid>
              )}
            </Card>

            <Card className="mt-10 p-5">
              <Typography variant="h2">Optional TEVV Documents</Typography>
              {templateList.length > 0 && !isLoading && (
                <Grid container spacing={3} mt={2}>
                  {templateList
                    .filter((obj) => !obj.isRequired)
                    .map((template) => (
                      <Grid xs={6} item spacing={3} sx={{ display: 'flex' }}>
                        {getTemplates(template)}
                      </Grid>
                    ))}
                </Grid>
              )}
            </Card>
          </>
        )}
      </Box>
    </>
  );
};

export default Complience;
